import { StarIcon } from '@heroicons/react/solid';
const TestimonialCard = ({ image, name, rating, testimony }) => {
  return (
    <div className="relative bg-white rounded-xl shadow-lg hover:shadow-2xl transform hover:scale-105 transition-all duration-500 p-6 text-center">
      <img
        className="w-16 h-16 mx-auto rounded-full border-4 border-gray-200 mb-4"
        src={image}
        alt={name}
      />
      <h3 className="text-xl font-semibold text-gray-900">{name}</h3>
      <div className="flex justify-center mt-2">
        {[...Array(5)].map((_, index) => (
          <StarIcon
            key={index}
            className={`h-6 w-6 ${
              index < rating ? 'text-yellow-400' : 'text-gray-300'
            } transition-all duration-300`}
          />
        ))}
      </div>
      <p className="mt-3 text-gray-600 text-sm">{testimony}</p>
    </div>
  );
};
export default TestimonialCard; 


